import React from 'react'

const Mandatory = () => {
  return (
    <label className="h4 ps-2 m-0 text-danger fw-bold">*</label>
  )
}

export default Mandatory;